import cls from 'classnames';
import { IProductMenu } from 'core/redux/features/products/types';
import TextEllipsis from '../../../Components/TextEllipsis';
import ProductPrice from '../../Products/Components/ProductPrice';
import React from 'react';
import { AppState } from 'core/redux/reducers';
import { selectTranslator } from 'core/redux/features/languages/trans';
import { connect } from 'react-redux';
import { ProductMenuSelectToggle } from './ProductMenuSelect';
import { actions } from 'core/redux/features/booking';
import { _get } from 'core/utils/object-prop';
import { selectStepData } from 'core/redux/features/shared/reducers';
import { BOOKING_STEP1 } from 'core/redux/features/booking/constants';
import { BookingStep1 } from 'core/redux/features/booking/types';

const mapStateToProps = (state: AppState) => {
  return {
    trans: selectTranslator(state),
    step: selectStepData(state, 'booking', BOOKING_STEP1) as BookingStep1,
  };
};

const mapDispatchToProps = {
  onUpdateMenu: actions.selectProductMenu,
};

type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    menu: IProductMenu;
    onHideMenuModal: () => void;
    status: string;
  };

class ProductMenuComp extends React.Component<IProps> {
  render() {
    const { menu, onUpdateMenu, step, status } = this.props;
    return (
      <div
        className={cls(
          'book-menus',
          status !== 'in-stock' && 'book-menu--disabled',
        )}
      >
        <div className={`book-menus__wrapper`} style={{}}>
          <div className="book-menu__space">
            <TextEllipsis className="book-menu__name" clump={2}>
              {menu.name}
            </TextEllipsis>
          </div>
          <div>
            <ProductMenuSelectToggle
              status={status}
              onlyTableSize={
                menu.all_table_size === 1 ? step.data.num_person : undefined
              }
              onChange={seat =>
                onUpdateMenu({
                  menu_id: menu.id,
                  num_person: seat,
                })
              }
              selected={
                _get(step.data.menus, menu.id, { num_person: 0 }).num_person
              }
            />
          </div>
          <div>
            <ProductPrice
              prices={[
                {
                  price: menu.price_sale,
                  type: 'sale',
                  isMultiline: true,
                  currency: 'KR',
                },
                {
                  price: menu.price_regular,
                  type: 'normal',
                  isMultiline: true,
                  currency: 'KR',
                },
              ]}
            />
          </div>
        </div>
      </div>
    );
  }
}

const ProductMenu = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductMenuComp);

export default ProductMenu;
